import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ExitToApp from '@material-ui/icons/ExitToApp';
import Favorite from '@material-ui/icons/Favorite';
import ThumbUp from '@material-ui/icons/ThumbUp';
import QuestionAnswer from '@material-ui/icons/QuestionAnswer';
import Share from '@material-ui/icons/Share';
import FormatListBulleted from '@material-ui/icons/FormatListBulleted';
import GridContainer from '@/components/material-ui-kit/components/Grid/GridContainer';
import GridItem from '@/components/material-ui-kit/components/Grid/GridItem';
import InfoArea from '@/components/common/ui/InfoArea';
import styles from 'styles/jss/original/components/about/aboutFunctionSection';

// @ts-expect-error
const useStyles = makeStyles(styles);

const functionList = [
  {
    icon: Share,
    title: '記事SNSシェア',
    description: ''
  },
  {
    icon: ExitToApp,
    title: 'ソーシャルログイン',
    description: ''
  },
  {
    icon: Favorite,
    title: 'お気に入り',
    description: ''
  },
  {
    icon: FormatListBulleted,
    title: '買い物リスト',
    description: ''
  },
  {
    icon: QuestionAnswer,
    title: 'アイテムへコメント',
    description: ''
  },
  {
    icon: ThumbUp,
    title: 'コメントへいいね',
    description: ''
  }
];

const SectionFeatures = () => {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <div className={classes.container}>
        {/* @ts-expect-error プロパティ「justify」は、タイプ「IntrinsicAttributes & Pick<InferProps<{ children.Requireable<ReactNodeLike>; className」に存在しません。*/}
        <GridContainer justify='center'>
          {/* @ts-expect-error */}
          <GridItem xs={12} sm={10} md={10}>
            <h3 className={classes.title}>主な機能</h3>
          </GridItem>
        </GridContainer>
        <GridContainer className={classes.textCenter}>
          {functionList.map((item) => {
            return (
              <>
                {/* @ts-expect-error */}
                <GridItem xs={6} sm={4} md={4} key={item.title}>
                  <InfoArea
                    vertical
                    icon={item.icon}
                    title={item.title}
                    description={item.description}
                    iconColor='warning'
                    className={classes.infoArea}
                  />
                </GridItem>
              </>
            );
          })}
        </GridContainer>
      </div>
    </div>
  );
};

export default SectionFeatures;
